
export const getConcernLevelColor = (level: string) => {
  switch (level) {
    case 'very_low': return 'bg-green-100 text-green-800';
    case 'low': return 'bg-blue-100 text-blue-800';
    case 'medium': return 'bg-yellow-100 text-yellow-800';
    case 'high': return 'bg-orange-100 text-orange-800';
    case 'very_high': return 'bg-red-100 text-red-800';
    default: return 'bg-gray-100 text-gray-800';
  }
};

export const getConcernLevelText = (level: string) => {
  switch (level) {
    case 'very_low': return 'Very Low';
    case 'low': return 'Low';
    case 'medium': return 'Medium';
    case 'high': return 'High';
    case 'very_high': return 'Very High';
    default: return 'Unknown';
  }
};
